"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DataLevel;

(function (DataLevel) {
  DataLevel[DataLevel["MyCompany"] = 0] = "MyCompany";
  DataLevel[DataLevel["MyOwn"] = 1] = "MyOwn";
})(DataLevel = exports.DataLevel || (exports.DataLevel = {}));

var SortDirection;

(function (SortDirection) {
  SortDirection[SortDirection["Descending"] = 0] = "Descending";
  SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));

var AboutTypes;

(function (AboutTypes) {
  AboutTypes[AboutTypes["NOTHING"] = 0] = "NOTHING";
  AboutTypes[AboutTypes["Company"] = 1] = "Company";
  AboutTypes[AboutTypes["Contact"] = 2] = "Contact";
  AboutTypes[AboutTypes["Opportunity"] = 3] = "Opportunity";
  AboutTypes[AboutTypes["Position"] = 4] = "Position";
  AboutTypes[AboutTypes["Match"] = 5] = "Match";
  AboutTypes[AboutTypes["Candidate"] = 6] = "Candidate";
  AboutTypes[AboutTypes["Recruiter"] = 7] = "Recruiter";
  AboutTypes[AboutTypes["CandidateApplication"] = 8] = "CandidateApplication";
  AboutTypes[AboutTypes["ScheduledItem"] = 9] = "ScheduledItem";
  AboutTypes[AboutTypes["RecruiterCommissionPlan"] = 10] = "RecruiterCommissionPlan";
  AboutTypes[AboutTypes["CandidateReference"] = 11] = "CandidateReference";
  AboutTypes[AboutTypes["Timesheet"] = 12] = "Timesheet";
  AboutTypes[AboutTypes["Agreement"] = 13] = "Agreement";
  AboutTypes[AboutTypes["Rate"] = 16] = "Rate";
  AboutTypes[AboutTypes["Invoice"] = 17] = "Invoice";
  AboutTypes[AboutTypes["Note"] = 18] = "Note";
  AboutTypes[AboutTypes["Transaction"] = 19] = "Transaction";
  AboutTypes[AboutTypes["VendorManager"] = 20] = "VendorManager";
  AboutTypes[AboutTypes["ClientProject"] = 21] = "ClientProject";
  AboutTypes[AboutTypes["ClientProjectMilestone"] = 22] = "ClientProjectMilestone";
  AboutTypes[AboutTypes["ShortlistedCandidate"] = 23] = "ShortlistedCandidate";
  AboutTypes[AboutTypes["Vendor"] = 31] = "Vendor";
  AboutTypes[AboutTypes["VendorContact"] = 37] = "VendorContact";
  AboutTypes[AboutTypes["EmailTemplate"] = 50] = "EmailTemplate";
  AboutTypes[AboutTypes["PrintTemplate"] = 51] = "PrintTemplate";
  AboutTypes[AboutTypes["InvoiceTemplate"] = 52] = "InvoiceTemplate";
  AboutTypes[AboutTypes["SignatureDocumentTemplate"] = 53] = "SignatureDocumentTemplate";
  AboutTypes[AboutTypes["DocumentSignature"] = 54] = "DocumentSignature";
  AboutTypes[AboutTypes["FolderGroup"] = 55] = "FolderGroup";
  AboutTypes[AboutTypes["Address"] = 60] = "Address";
  AboutTypes[AboutTypes["Department"] = 61] = "Department";
  AboutTypes[AboutTypes["CompanyDepartment"] = 62] = "CompanyDepartment";
  AboutTypes[AboutTypes["FacilityDepartment"] = 63] = "FacilityDepartment";
  AboutTypes[AboutTypes["LegalCase"] = 70] = "LegalCase";
  AboutTypes[AboutTypes["Litigation"] = 71] = "Litigation";
  AboutTypes[AboutTypes["MarketingCampaign"] = 80] = "MarketingCampaign";
  AboutTypes[AboutTypes["Seed"] = 90] = "Seed";
  AboutTypes[AboutTypes["HRNetPage"] = 100] = "HRNetPage";
  AboutTypes[AboutTypes["Communication"] = 111] = "Communication";
  AboutTypes[AboutTypes["WorkflowAction"] = 200] = "WorkflowAction";
  AboutTypes[AboutTypes["Attachment"] = 210] = "Attachment";
  AboutTypes[AboutTypes["ObjectRequirement"] = 220] = "ObjectRequirement";
  AboutTypes[AboutTypes["RequirementDefinition"] = 221] = "RequirementDefinition";
  AboutTypes[AboutTypes["Incident"] = 230] = "Incident";
  AboutTypes[AboutTypes["ScheduledEmail"] = 240] = "ScheduledEmail";
  AboutTypes[AboutTypes["Shift"] = 250] = "Shift";
  AboutTypes[AboutTypes["ShiftCancellation"] = 251] = "ShiftCancellation";
  AboutTypes[AboutTypes["WorkHistory"] = 260] = "WorkHistory";
  AboutTypes[AboutTypes["EducationHistory"] = 270] = "EducationHistory";
  AboutTypes[AboutTypes["RateGroup"] = 290] = "RateGroup";
  AboutTypes[AboutTypes["PositionTemplate"] = 300] = "PositionTemplate";
  AboutTypes[AboutTypes["Division"] = 310] = "Division";
  AboutTypes[AboutTypes["DivisionMarket"] = 315] = "DivisionMarket";
  AboutTypes[AboutTypes["TimesheetLineAttribution"] = 320] = "TimesheetLineAttribution";
  AboutTypes[AboutTypes["TimesheetLineEntry"] = 321] = "TimesheetLineEntry";
  AboutTypes[AboutTypes["CredentialingRequest"] = 325] = "CredentialingRequest";
  AboutTypes[AboutTypes["TimesheetFieldValue"] = 326] = "TimesheetFieldValue";
  AboutTypes[AboutTypes["TimesheetFieldDefinition"] = 327] = "TimesheetFieldDefinition";
  AboutTypes[AboutTypes["CandidateDirectDeposit"] = 328] = "CandidateDirectDeposit";
  AboutTypes[AboutTypes["DirectDepositAccountType"] = 329] = "DirectDepositAccountType";
  AboutTypes[AboutTypes["CandidateStateW4Info"] = 330] = "CandidateStateW4Info";
  AboutTypes[AboutTypes["MinimumWage"] = 331] = "MinimumWage";
  AboutTypes[AboutTypes["CandidateTaxCanada"] = 332] = "CandidateTaxCanada";
  AboutTypes[AboutTypes["TimeAndLaborSetup"] = 333] = "TimeAndLaborSetup";
  AboutTypes[AboutTypes["CandidateTaxUsa"] = 334] = "CandidateTaxUsa";
  AboutTypes[AboutTypes["TimesheetField"] = 335] = "TimesheetField";
  AboutTypes[AboutTypes["TimesheetFieldValueDefaults"] = 336] = "TimesheetFieldValueDefaults";
  AboutTypes[AboutTypes["PositionType"] = 1001] = "PositionType";
  AboutTypes[AboutTypes["RecruiterDepartment"] = 1002] = "RecruiterDepartment";
  AboutTypes[AboutTypes["ObjectRelationship"] = 1003] = "ObjectRelationship";
  AboutTypes[AboutTypes["Onboarding"] = 1004] = "Onboarding";
  AboutTypes[AboutTypes["SavedSearch"] = 1005] = "SavedSearch";
  AboutTypes[AboutTypes["OpportunityType"] = 1006] = "OpportunityType";
  AboutTypes[AboutTypes["VendorProjectsPricing"] = 1007] = "VendorProjectsPricing";
  AboutTypes[AboutTypes["CompanyEINMap"] = 1008] = "CompanyEINMap";
  AboutTypes[AboutTypes["PositionAutoPublishRule"] = 1009] = "PositionAutoPublishRule";
  AboutTypes[AboutTypes["VMSSyncCompanyMap"] = 1010] = "VMSSyncCompanyMap";
  AboutTypes[AboutTypes["ContactStatus"] = 1011] = "ContactStatus";
  AboutTypes[AboutTypes["CompanyStatus"] = 1012] = "CompanyStatus";
  AboutTypes[AboutTypes["PositionStatus"] = 1013] = "PositionStatus";
  AboutTypes[AboutTypes["CandidateStatus"] = 1014] = "CandidateStatus";
  AboutTypes[AboutTypes["CustomField"] = 1015] = "CustomField";
  AboutTypes[AboutTypes["ElectronicFundsTransfer"] = 1016] = "ElectronicFundsTransfer";
  AboutTypes[AboutTypes["CandidateApplicationRejectionReason"] = 1017] = "CandidateApplicationRejectionReason";
  AboutTypes[AboutTypes["InvoiceDetailGridDocument"] = 1018] = "InvoiceDetailGridDocument";
  AboutTypes[AboutTypes["NoteAction"] = 1019] = "NoteAction";
  AboutTypes[AboutTypes["ScheduledItemType"] = 1020] = "ScheduledItemType";
  AboutTypes[AboutTypes["InvoiceCancelled"] = 1021] = "InvoiceCancelled";
  AboutTypes[AboutTypes["ScheduledItemCategory"] = 1022] = "ScheduledItemCategory";
  AboutTypes[AboutTypes["ContactType"] = 1023] = "ContactType";
  AboutTypes[AboutTypes["PositionCloseReason"] = 1024] = "PositionCloseReason";
  AboutTypes[AboutTypes["MatchEndReason"] = 1025] = "MatchEndReason";
  AboutTypes[AboutTypes["TagAssignment"] = 1026] = "TagAssignment";
  AboutTypes[AboutTypes["Tag"] = 1027] = "Tag";
  AboutTypes[AboutTypes["CandidateTerminationReason"] = 1028] = "CandidateTerminationReason";
  AboutTypes[AboutTypes["ThirdPartyValue"] = 1029] = "ThirdPartyValue";
  AboutTypes[AboutTypes["AdditionalOwner"] = 1030] = "AdditionalOwner";
  AboutTypes[AboutTypes["ScheduledItemStatus"] = 1031] = "ScheduledItemStatus";
  AboutTypes[AboutTypes["PayrollTaxRequest"] = 1032] = "PayrollTaxRequest";
  AboutTypes[AboutTypes["SalesTaxThomsonReutersLog"] = 1033] = "SalesTaxThomsonReutersLog";
  AboutTypes[AboutTypes["WorkersCompensation"] = 1034] = "WorkersCompensation";
  AboutTypes[AboutTypes["CourierMessage"] = 1035] = "CourierMessage";
  AboutTypes[AboutTypes["OnboardingDocumentDefinition"] = 1036] = "OnboardingDocumentDefinition";
  AboutTypes[AboutTypes["OnboardingTemplate"] = 1037] = "OnboardingTemplate";
  AboutTypes[AboutTypes["OnboardingDocument"] = 1038] = "OnboardingDocument";
  AboutTypes[AboutTypes["OnboardingCancellationReason"] = 1039] = "OnboardingCancellationReason";
  AboutTypes[AboutTypes["CommunicationType"] = 1040] = "CommunicationType";
  AboutTypes[AboutTypes["HelpTip"] = 1041] = "HelpTip";
  AboutTypes[AboutTypes["FolderGroupStatus"] = 1042] = "FolderGroupStatus";
  AboutTypes[AboutTypes["RequirementRejectionReason"] = 1043] = "RequirementRejectionReason";
  AboutTypes[AboutTypes["CandidateRating"] = 1044] = "CandidateRating";
  AboutTypes[AboutTypes["Goal"] = 1045] = "Goal";
  AboutTypes[AboutTypes["GPExportScheduleRun"] = 1046] = "GPExportScheduleRun";
  AboutTypes[AboutTypes["PONumber"] = 1050] = "PONumber";
  AboutTypes[AboutTypes["OnboardingStatus"] = 1060] = "OnboardingStatus";
  AboutTypes[AboutTypes["BackOfficeCustomer"] = 1070] = "BackOfficeCustomer";
  AboutTypes[AboutTypes["ProcessingProfile"] = 1080] = "ProcessingProfile";
  AboutTypes[AboutTypes["ProcessingProfileDetails"] = 1081] = "ProcessingProfileDetails";
  AboutTypes[AboutTypes["Worksite"] = 1090] = "Worksite";
  AboutTypes[AboutTypes["AdjustmentRequest"] = 1091] = "AdjustmentRequest";
  AboutTypes[AboutTypes["PendingBulkUpdate"] = 1092] = "PendingBulkUpdate";
  AboutTypes[AboutTypes["CompanyType"] = 1093] = "CompanyType";
  AboutTypes[AboutTypes["ValidationError"] = 1094] = "ValidationError";
  AboutTypes[AboutTypes["TimesheetLinePay"] = 1095] = "TimesheetLinePay";
  AboutTypes[AboutTypes["AddressReference"] = 1096] = "AddressReference";
  AboutTypes[AboutTypes["MatchPayrollTax"] = 1097] = "MatchPayrollTax";
  AboutTypes[AboutTypes["CandidateApplicationStatus"] = 1098] = "CandidateApplicationStatus";
  AboutTypes[AboutTypes["ShortlistedCandidateStatus"] = 1099] = "ShortlistedCandidateStatus";
  AboutTypes[AboutTypes["StagedImportBatch"] = 2001] = "StagedImportBatch";
  AboutTypes[AboutTypes["RunningScriptFork"] = 2002] = "RunningScriptFork";
  AboutTypes[AboutTypes["ImportBatch"] = 2003] = "ImportBatch";
  AboutTypes[AboutTypes["ImportMatchBatch"] = 2005] = "ImportMatchBatch";
  AboutTypes[AboutTypes["VendorCompanyDetails"] = 2006] = "VendorCompanyDetails";
  AboutTypes[AboutTypes["CandidateElectronicFundsTransfer"] = 2007] = "CandidateElectronicFundsTransfer";
  AboutTypes[AboutTypes["RateDefinition"] = 2008] = "RateDefinition";
  AboutTypes[AboutTypes["TaskErrorLog"] = 2009] = "TaskErrorLog";
  AboutTypes[AboutTypes["ImportTimesheetBatch"] = 2010] = "ImportTimesheetBatch";
})(AboutTypes = exports.AboutTypes || (exports.AboutTypes = {}));

var PositionTemplateFieldType;

(function (PositionTemplateFieldType) {
  PositionTemplateFieldType[PositionTemplateFieldType["AdminBurden"] = 1] = "AdminBurden";
  PositionTemplateFieldType[PositionTemplateFieldType["Agreement"] = 2] = "Agreement";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowFacilityDepartmentSubSet"] = 3] = "AllowFacilityDepartmentSubSet";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowShiftTypeSubSet"] = 4] = "AllowShiftTypeSubSet";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowSubmittalsAboveMaxVendorRemitPay"] = 5] = "AllowSubmittalsAboveMaxVendorRemitPay";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowSubmittalsAboveBelowMinVendorRemitPay"] = 6] = "AllowSubmittalsAboveBelowMinVendorRemitPay";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowSubmittalsAboveCandidateMaxPay"] = 7] = "AllowSubmittalsAboveCandidateMaxPay";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowSubmittalsAfterEstimatedEndDate"] = 8] = "AllowSubmittalsAfterEstimatedEndDate";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowSubmittalsBeforeTheEstimatedStartDate"] = 9] = "AllowSubmittalsBeforeTheEstimatedStartDate";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowSubmittalsBelowCandidateMinPay"] = 10] = "AllowSubmittalsBelowCandidateMinPay";
  PositionTemplateFieldType[PositionTemplateFieldType["AllowZeroHourTimesheets"] = 11] = "AllowZeroHourTimesheets";
  PositionTemplateFieldType[PositionTemplateFieldType["AssociatedRateGroups"] = 12] = "AssociatedRateGroups";
  PositionTemplateFieldType[PositionTemplateFieldType["Citizenship"] = 13] = "Citizenship";
  PositionTemplateFieldType[PositionTemplateFieldType["ClearanceLevel"] = 14] = "ClearanceLevel";
  PositionTemplateFieldType[PositionTemplateFieldType["ClientProject"] = 15] = "ClientProject";
  PositionTemplateFieldType[PositionTemplateFieldType["ClientReferenceNumber"] = 16] = "ClientReferenceNumber";
  PositionTemplateFieldType[PositionTemplateFieldType["Duration"] = 18] = "Duration";
  PositionTemplateFieldType[PositionTemplateFieldType["EndTime"] = 19] = "EndTime";
  PositionTemplateFieldType[PositionTemplateFieldType["EstimatedEndDate"] = 20] = "EstimatedEndDate";
  PositionTemplateFieldType[PositionTemplateFieldType["EstimatedStartDate"] = 21] = "EstimatedStartDate";
  PositionTemplateFieldType[PositionTemplateFieldType["ExpenseType"] = 22] = "ExpenseType";
  PositionTemplateFieldType[PositionTemplateFieldType["FacilityDepartments"] = 23] = "FacilityDepartments";
  PositionTemplateFieldType[PositionTemplateFieldType["FolderGroup"] = 24] = "FolderGroup";
  PositionTemplateFieldType[PositionTemplateFieldType["GeneralComments"] = 25] = "GeneralComments";
  PositionTemplateFieldType[PositionTemplateFieldType["Industry"] = 26] = "Industry";
  PositionTemplateFieldType[PositionTemplateFieldType["InternalSource"] = 27] = "InternalSource";
  PositionTemplateFieldType[PositionTemplateFieldType["MaxNumberOfSubmittals"] = 28] = "MaxNumberOfSubmittals";
  PositionTemplateFieldType[PositionTemplateFieldType["NotesToBackOffice"] = 29] = "NotesToBackOffice";
  PositionTemplateFieldType[PositionTemplateFieldType["NumberOfPositions"] = 30] = "NumberOfPositions";
  PositionTemplateFieldType[PositionTemplateFieldType["Opportunity"] = 31] = "Opportunity";
  PositionTemplateFieldType[PositionTemplateFieldType["PositionDescription"] = 32] = "PositionDescription";
  PositionTemplateFieldType[PositionTemplateFieldType["PositionCreationReason"] = 33] = "PositionCreationReason";
  PositionTemplateFieldType[PositionTemplateFieldType["PositionCreationReasonNote"] = 34] = "PositionCreationReasonNote";
  PositionTemplateFieldType[PositionTemplateFieldType["PositionSource"] = 35] = "PositionSource";
  PositionTemplateFieldType[PositionTemplateFieldType["PositionTitle"] = 36] = "PositionTitle";
  PositionTemplateFieldType[PositionTemplateFieldType["PositionType"] = 37] = "PositionType";
  PositionTemplateFieldType[PositionTemplateFieldType["PrimaryDepartment"] = 38] = "PrimaryDepartment";
  PositionTemplateFieldType[PositionTemplateFieldType["ProcessingProfile"] = 39] = "ProcessingProfile";
  PositionTemplateFieldType[PositionTemplateFieldType["ReportsTo"] = 40] = "ReportsTo";
  PositionTemplateFieldType[PositionTemplateFieldType["RequestFunding"] = 41] = "RequestFunding";
  PositionTemplateFieldType[PositionTemplateFieldType["RequestFundingDetails"] = 42] = "RequestFundingDetails";
  PositionTemplateFieldType[PositionTemplateFieldType["SalesTax"] = 43] = "SalesTax";
  PositionTemplateFieldType[PositionTemplateFieldType["ShareWithDepartments"] = 44] = "ShareWithDepartments";
  PositionTemplateFieldType[PositionTemplateFieldType["ShareWithDistributionLists"] = 45] = "ShareWithDistributionLists";
  PositionTemplateFieldType[PositionTemplateFieldType["ShiftTypes"] = 46] = "ShiftTypes";
  PositionTemplateFieldType[PositionTemplateFieldType["StartTime"] = 47] = "StartTime";
  PositionTemplateFieldType[PositionTemplateFieldType["SubmittalBCC"] = 48] = "SubmittalBCC";
  PositionTemplateFieldType[PositionTemplateFieldType["SubmittalCC"] = 49] = "SubmittalCC";
  PositionTemplateFieldType[PositionTemplateFieldType["SubmittalLimitPerVendor"] = 50] = "SubmittalLimitPerVendor";
  PositionTemplateFieldType[PositionTemplateFieldType["Supervisor"] = 51] = "Supervisor";
  PositionTemplateFieldType[PositionTemplateFieldType["TimesheetApprover"] = 52] = "TimesheetApprover";
  PositionTemplateFieldType[PositionTemplateFieldType["TimesheetEntryTemplate"] = 53] = "TimesheetEntryTemplate";
  PositionTemplateFieldType[PositionTemplateFieldType["TimesheetNotification"] = 54] = "TimesheetNotification";
  PositionTemplateFieldType[PositionTemplateFieldType["TimesheetRangeCalendar"] = 55] = "TimesheetRangeCalendar";
  PositionTemplateFieldType[PositionTemplateFieldType["TravelPercentage"] = 56] = "TravelPercentage";
  PositionTemplateFieldType[PositionTemplateFieldType["WorkFromHome"] = 57] = "WorkFromHome";
  PositionTemplateFieldType[PositionTemplateFieldType["WorkHours"] = 58] = "WorkHours";
  PositionTemplateFieldType[PositionTemplateFieldType["WorkedInLocal"] = 59] = "WorkedInLocal";
  PositionTemplateFieldType[PositionTemplateFieldType["WorkersComp"] = 60] = "WorkersComp";
  PositionTemplateFieldType[PositionTemplateFieldType["WorksiteAddress"] = 61] = "WorksiteAddress";
  PositionTemplateFieldType[PositionTemplateFieldType["YearsExperience"] = 62] = "YearsExperience";
  PositionTemplateFieldType[PositionTemplateFieldType["CustomFields"] = 63] = "CustomFields";
})(PositionTemplateFieldType = exports.PositionTemplateFieldType || (exports.PositionTemplateFieldType = {}));

var RequestFundingType;

(function (RequestFundingType) {
  RequestFundingType[RequestFundingType["Base"] = 0] = "Base";
  RequestFundingType[RequestFundingType["Project"] = 1] = "Project";
})(RequestFundingType = exports.RequestFundingType || (exports.RequestFundingType = {}));

var MatchEndType;

(function (MatchEndType) {
  MatchEndType[MatchEndType["None"] = 0] = "None";
  MatchEndType[MatchEndType["End"] = 1] = "End";
  MatchEndType[MatchEndType["Extend"] = 2] = "Extend";
  MatchEndType[MatchEndType["Convert"] = 4] = "Convert";
  MatchEndType[MatchEndType["Cancel"] = 8] = "Cancel";
  MatchEndType[MatchEndType["Reject"] = 16] = "Reject";
  MatchEndType[MatchEndType["FallOff"] = 32] = "FallOff";
  MatchEndType[MatchEndType["Renew"] = 64] = "Renew";
})(MatchEndType = exports.MatchEndType || (exports.MatchEndType = {}));

var CustomFieldType;

(function (CustomFieldType) {
  CustomFieldType[CustomFieldType["String"] = 1] = "String";
  CustomFieldType[CustomFieldType["Integer"] = 2] = "Integer";
  CustomFieldType[CustomFieldType["Boolean"] = 3] = "Boolean";
  CustomFieldType[CustomFieldType["Money"] = 4] = "Money";
  CustomFieldType[CustomFieldType["Percent"] = 5] = "Percent";
  CustomFieldType[CustomFieldType["List"] = 6] = "List";
  CustomFieldType[CustomFieldType["DateTime"] = 7] = "DateTime";
  CustomFieldType[CustomFieldType["URL"] = 8] = "URL";
  CustomFieldType[CustomFieldType["Number"] = 9] = "Number";
  CustomFieldType[CustomFieldType["Label"] = 10] = "Label";
  CustomFieldType[CustomFieldType["File"] = 11] = "File";
  CustomFieldType[CustomFieldType["BigString"] = 12] = "BigString";
  CustomFieldType[CustomFieldType["UserControl"] = 13] = "UserControl";
  CustomFieldType[CustomFieldType["DatePicker"] = 14] = "DatePicker";
  CustomFieldType[CustomFieldType["CheckboxList"] = 15] = "CheckboxList";
  CustomFieldType[CustomFieldType["Password"] = 16] = "Password";
  CustomFieldType[CustomFieldType["RemoteList"] = 18] = "RemoteList";
})(CustomFieldType = exports.CustomFieldType || (exports.CustomFieldType = {}));

var ShiftStatuses;

(function (ShiftStatuses) {
  ShiftStatuses[ShiftStatuses["Open"] = 1] = "Open";
  ShiftStatuses[ShiftStatuses["Closed"] = 2] = "Closed";
  ShiftStatuses[ShiftStatuses["Cancelled"] = 3] = "Cancelled";
})(ShiftStatuses = exports.ShiftStatuses || (exports.ShiftStatuses = {}));

var InexactDurationUnit;

(function (InexactDurationUnit) {
  InexactDurationUnit[InexactDurationUnit["Hour"] = 0] = "Hour";
  InexactDurationUnit[InexactDurationUnit["Day"] = 1] = "Day";
  InexactDurationUnit[InexactDurationUnit["Week"] = 2] = "Week";
  InexactDurationUnit[InexactDurationUnit["Month"] = 3] = "Month";
  InexactDurationUnit[InexactDurationUnit["Year"] = 4] = "Year";
  InexactDurationUnit[InexactDurationUnit["Weekday"] = 5] = "Weekday";
})(InexactDurationUnit = exports.InexactDurationUnit || (exports.InexactDurationUnit = {}));

var UserNotificationType;

(function (UserNotificationType) {
  UserNotificationType[UserNotificationType["PositionApprovalStarted"] = 0] = "PositionApprovalStarted";
  UserNotificationType[UserNotificationType["MatchApprovalStarted"] = 1] = "MatchApprovalStarted";
  UserNotificationType[UserNotificationType["PositionApprovalPending"] = 2] = "PositionApprovalPending";
  UserNotificationType[UserNotificationType["MatchApprovalPending"] = 3] = "MatchApprovalPending";
  UserNotificationType[UserNotificationType["PositionApprovalCompleted"] = 4] = "PositionApprovalCompleted";
  UserNotificationType[UserNotificationType["MatchApprovalCompleted"] = 5] = "MatchApprovalCompleted";
  UserNotificationType[UserNotificationType["PositionApprovalRejected"] = 6] = "PositionApprovalRejected";
  UserNotificationType[UserNotificationType["MatchApprovalRejected"] = 7] = "MatchApprovalRejected";
  UserNotificationType[UserNotificationType["CandidateSubmitted"] = 8] = "CandidateSubmitted";
  UserNotificationType[UserNotificationType["CandidateAcceptedOffer"] = 9] = "CandidateAcceptedOffer";
  UserNotificationType[UserNotificationType["PositionApprovalNeedsApprovers"] = 10] = "PositionApprovalNeedsApprovers";
  UserNotificationType[UserNotificationType["MatchApprovalNeedsApprovers"] = 11] = "MatchApprovalNeedsApprovers";
})(UserNotificationType = exports.UserNotificationType || (exports.UserNotificationType = {}));

var UserNotificationChannel;

(function (UserNotificationChannel) {
  UserNotificationChannel[UserNotificationChannel["Email"] = 0] = "Email";
  UserNotificationChannel[UserNotificationChannel["Push"] = 1] = "Push";
})(UserNotificationChannel = exports.UserNotificationChannel || (exports.UserNotificationChannel = {}));

var BroadcastMessagePriority;

(function (BroadcastMessagePriority) {
  BroadcastMessagePriority[BroadcastMessagePriority["Info"] = 0] = "Info";
  BroadcastMessagePriority[BroadcastMessagePriority["Warning"] = 1] = "Warning";
  BroadcastMessagePriority[BroadcastMessagePriority["Important"] = 2] = "Important";
})(BroadcastMessagePriority = exports.BroadcastMessagePriority || (exports.BroadcastMessagePriority = {}));

var BroadcastMessageApplication;

(function (BroadcastMessageApplication) {
  BroadcastMessageApplication[BroadcastMessageApplication["ClientContactPortal"] = 0] = "ClientContactPortal";
})(BroadcastMessageApplication = exports.BroadcastMessageApplication || (exports.BroadcastMessageApplication = {}));